import Rook from './Rook';
import { RookController } from './rookController';

export default Rook;
export { RookController };